import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";
import { SecurityAclContext, AuthCheckAcl } from "../Security.js";
import Accordion from "../pages/abstract/Accordion.js";

export default class PageCommon {
    constructor() {
        this.btnToggleUserMenu = document.querySelector(".js-toggle-btn[data-toggle='user-action']");
        this.userMenu = document.querySelector(".js-menu-user-action");
        this.userMenuVisible = false;
    }
    init($data) {

        //Pqp.trace("PageCommon");
        this.metaInfo = ($data && $data.metaInfo) ? $data.metaInfo : null;
        //
        if (this.metaInfo) {
            history.replaceState(history.state, this.metaInfo.Title, this.metaInfo.Url + location.hash);
            document.title = metaInfo.Title;
        }

        if (window.innerWidth <= 1280) {
            $('.sidebar-menu').toggleClass("collapsed");
            $('.app-content').toggleClass("collapsed");
        }
        // page id
        if ($data && $data.page && $data.page.PageId) {
            let split = StateManager._splitUrl(document.location.href);
            split.qPart["_pi"] = $data.page.PageId; // page id
            delete split.qPart["__pi"]; // = canonical back page id
            let qs = "";
            for (let k in split.qPart)
                qs += (qs == "" ? "" : "&") + k + "=" + encodeURIComponent(split.qPart[k]);
            let u = split.url + "?" + qs + (split.Hash != "" ? split.Hash : "");
            history.replaceState(history.state /*history.state*/, document.title, u /*document.location*/);
        }
        // acl context
        this.aclContext = new SecurityAclContext(true);
        /*
                 debugger;
                 let ok = this.aclContext.HasGrantedAcl(new AuthCheckAcl("LOOKUP:READ"));
                 let ccc = this.aclContext.GetAllGrantedAcl("/LOOKUP/_GROUPS/chest/_LOOKUPS/chest_chestdimensiontype")
        */
        //
        //this.initShieldCommonComponents();
        $(".js-logout").on("click", this.doLogout.bind(this));
        $(".js-alert").on("click", this.goAlert.bind(this));
        if (window.location.href.indexOf("#alert") > -1) {
            let al = $("#alert-section").offset().top;
            let alertSection = document.querySelector('#alert-section');
            if (alertSection) {
                $("body,html").animate({
                    scrollTop: al * 2.5
                }, 500)
            }
        }
        $(".js-toggle-btn").on("click", (e) => {
            let target = e.target;
            // console.log(target);
            let toggle = target.dataset.toggle;
            target.classList.toggle("active");
            let toToggle = document.querySelector(`.js-menu-${toggle}`);
            if (toToggle) {
                toToggle.classList.toggle("active");
            }
        });
        //this.initializeSidebar();
        $(".btn-collapse-menu").on("click", $.proxy(this.collapseMenu, this));
        $(".js-tab-btn").on("click", $.proxy(this.activeTab, this));
        /*$('input[type="checkbox"]').change((e) => {
            console.log(e.target);
            if ($(e.target).is(":checked")) {
            	
                $(e.target).val('true')
            } else {
                $(e.target).val('false');
            }
        })*/
        // dispaccio un evento globale
        try {
            this.dispatchInitEvent(TheDisp.EV_PAGECOMMON_INITED);
        } catch (error) {
            console.log(error);
        }
        StateManager.initialize();
        try {
            let stat = StateManager.getViewState("frm");
            if (stat.m === "u") {
                //console.log("IN UPDATE");
            }
        } catch (e) {
            //console.log(e);
        }
        $(".jsSearchHeader").on("click", this.onSearchHeader.bind(this,false));
        $("#filtersearch").on("keyup", this.onSearchHeader.bind(this, true));

        $(".js-nav-submenu-toggle").on("click", (e) => {
            this.doToggleSidebarItem(e);
        });

        this.initAccordions();

        this.btnToggleUserMenu?.addEventListener("click", (e) => {
            e.stopPropagation();
            this.userMenuVisible = !this.userMenuVisible;
            this.userMenu.classList.toggle("active", this.userMenuVisible);
        });
        document.body.addEventListener("click", (e) => {
            if (this.userMenuVisible &&
                !this.userMenu.contains(e.target) &&
                !this.btnToggleUserMenu.contains(e.target)) {
                this.userMenu.classList.remove("active");
                this.userMenuVisible = false;
            }
        });

    }
    onBtnToggleUserMenuClick(e) {
        e.stopPropagation();
        this.userMenuVisible = !this.userMenuVisible;

        if (this.userMenuVisible) {
            this.btnToggleUserMenu.classList.add("is-active");
            this.userMenu?.classList.add("is-active");
            this.userMenu?.removeAttribute("inert");
        } else {
            this.hideUserMenu();
        }
    }

    hideUserMenu() {
        if (!this.userMenuVisible) return;

        this.userMenuVisible = false;
        this.btnToggleUserMenu?.classList.remove("is-active");
        this.userMenu?.classList.remove("is-active");
        this.userMenu?.setAttribute("inert", "");
    }


    initAccordions() {
        const accordions = document.querySelectorAll(".js-accordion");
        accordions?.forEach(acc => {
            const accordion = new Accordion(acc);
            accordion?.init();
        });
    }


    goAlert() {
        let home = document.querySelector('.home-wrapper');
        if (home) {
            let al = $("#alert-section").offset().top;
            $("body,html").animate({
                scrollTop: al
            }, 500)
        } else {
            window.location.href = '/#alert'
        }


    }

    doToggleSidebarItem(e) {
        var target = e.currentTarget;
        var parentVar = $(target).parent();

        $(".nav-submenu", $(parentVar)).toggleClass("collapsed");

        var collapsed = $(".nav-submenu", $(parentVar)).hasClass("collapsed");
        if (!$(".sidebar-menu").hasClass("collapsed")) {
            if (collapsed) {
                $(".nav-submenu-icon", target).removeClass('fa-chevron-down').addClass('fa-chevron-up');
            }
            else {
                $(".nav-submenu-icon", target).removeClass('fa-chevron-up').addClass('fa-chevron-down');
            }
        }
    }

    doLogout() {
        AuthWiz.doLogout("/");
    }
    activeTab(e) {
        let target = e.target;
        let toggle = target.dataset.tab;
        let btnTabs = document.querySelectorAll(".js-tab-btn");
        btnTabs.forEach((el) => {
            el.classList.remove("active");
        });
        target.classList.add("active");
        let tabs = document.querySelectorAll(".single-tab");
        tabs.forEach((el) => {
            el.classList.remove("active");
        });
        let tab = document.querySelector(`.js-tab-${toggle}`);
        tab.classList.add("active");
    }


    /*initShieldCommonComponents() {
        // $(".js-shield-dropdown").shieldDropDown();
        console.log("PageCommon::initShieldCommonComponents to override?");
        $(".js-html-editor").shieldEditor({
            commands: [
                "bold", "italic", "underline",
                "insertUnorderedList", "insertOrderedList",
            ]
        });
    }*/


    collapseMenu() {
        $(".sidebar-menu").toggleClass("collapsed");

        if ($(".sidebar-menu").hasClass("collapsed")) {
            document.cookie = "sidebar-collapsed=true; path=/";
        } else {
            document.cookie = "sidebar-collapsed=false; path=/";
        }
    }

    dispatchInitEvent(evenTyepe) {
        // dispaccio un evento globale
        let ev = new Event(evenTyepe);
        ev.payload = { page: this }
        TheDisp.dispatchEvent(ev);
    }

    get isHomepage() {
        return false;

    }

    showPreloader(flag, percent = null) {
        if (flag) {
            if (percent == null) {
                $(".js-percent", $(".js-preloader")).hide();
            } else {
                $(".js-percent", $(".js-preloader")).show();
                $(".js-percent", $(".js-preloader")).text(percent);
            }
            jQuery(".js-preloader").show();
        } else {
            jQuery(".js-preloader").hide();
        }
    }

    static showPreloader(flag, percent = null) {
        if (flag) {
            if (percent == null) {
                $(".js-percent", $(".js-preloader")).hide();
            } else {
                $(".js-percent", $(".js-preloader")).show();
                $(".js-percent", $(".js-preloader")).text(percent);
            }
            jQuery(".js-preloader").show();
        } else {
            jQuery(".js-preloader").hide();
        }
    }


    track() {
        if (Globals.SHOW_TRACKING_DATA) {
            console.log("---tracking---");
            console.log("Event: " + PageCommon._normalizza_track_prop(o.event));
            console.log("Category: " + PageCommon._normalizza_track_prop(o.category));
            console.log("Label: " + o.label ? PageCommon._normalizza_track_prop(o.label) : "n/a");
        }

        let additional = {
            event_category: PageCommon._normalizza_track_prop(o.category)
        }
        if (o.label) {
            additional.event_label = PageCommon._normalizza_track_prop(o.label);
        }

        gtag('event', PageCommon._normalizza_track_prop(o.event), additional);

    }

    _normalizza_track_prop(s) {
        let ret = s.toLowerCase();
        ret = Pqp.safeReplace(ret, " ", "_");
        ret = Pqp.safeReplace(ret, "'", "_");
        ret = Pqp.safeReplace(ret, ".", "");
        ret = Pqp.safeReplace(ret, ",", "");
        ret = Pqp.safeReplace(ret, "(", "_");
        ret = Pqp.safeReplace(ret, ")", "");
        ret = Pqp.safeReplace(ret, "__", "_");
        return ret;
    }

    static disable(mc, lFlag, opacity = 0.5) {
        if (lFlag) {
            mc.css("pointer-events", "none");
            mc.css("opacity", opacity);
        } else {
            mc.css("pointer-events", "all");
            mc.css("opacity", 1);
        }

    }

    headerEventHandler(e) {

    }

    onSearchHeader(onKyeUp, event) {
        if (onKyeUp == true) {
            if (event.keyCode != 13)
                return;
            event.preventDefault();
        }

        var filter = $('#filtersearch').val();
             let state = {
            p: -1,    // page
            s: {},  // sort
            t: filter   // text
        }
        var sez = $('#dropdownsearch').find(":selected").val();
        StateManager.setViewState("jsList", state);
        let args = StateManager._splitUrl(document.location.href);
        let url = "?_vs=" + encodeURIComponent(args.qPart["_vs"]);
        document.location.href = TheApp.Env.BaseUrlNls + sez.toLowerCase() + "/" + url;
    }

}



